import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/** Montant en euros au format français, au centime : « 1 234,50 € ». */
export function euros(n: number | string | null | undefined) {
  return `${new Intl.NumberFormat('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(n) || 0)} €`
}

/** Cotisation d'un contrat selon son fractionnement (annuel : prime annuelle exacte). */
export function formatCotisation(c: { monthlyPrice?: string | number | null; yearlyPrice?: string | number | null; fractionnement?: string | null }) {
  if (c.fractionnement === 'annuel') {
    const an = c.yearlyPrice != null ? Number(c.yearlyPrice) : c.monthlyPrice != null ? Number(c.monthlyPrice) * 12 : null
    return an ? `${euros(an)}/an` : '—'
  }
  return c.monthlyPrice ? `${euros(c.monthlyPrice)}/mois` : '—'
}

/** Libellés des sites d'origine (contacts et devis). */
export const ORIGIN_SITE_LABELS: Record<string, string> = {
  'finance-for-you.com': 'Finance-For-You',
  'comparateur-assurance.com': 'Comparateur-Assurance',
  backoffice: 'Back-Office',
  bordereau: 'Import Bordereau',
  portefeuille: 'Portefeuille repris',
}
